import { on } from 'delegated-events'
import { Swiper, EffectFade, Navigation } from 'swiper'

Swiper.use([Navigation, EffectFade])

const $slider = document.querySelector('.history-slider')
const $navSlider = document.querySelector('.history-nav-slider')

const fn = {
    init: () => {
        const slider = new Swiper($slider, {
            spaceBetween: 10,
            speed: 500,
            slidesPerView: 'auto',
            autoHeight: true,
            centeredSlides: true,
        })

        const navSlider = new Swiper($navSlider, {
            on: {
                slideChange: function () {
                    slider.slideTo(this.activeIndex)

                    const $activeYear = document.querySelector(
                        '.milestone-year.is-active'
                    )

                    if ($activeYear) {
                        $activeYear.classList.remove('is-active')
                    }

                    if (this.activeIndex === this.slides.length - 1) {
                        document
                            .querySelector('.milestone-year.is-today')
                            .classList.add('is-active')
                    } else {
                        document
                            .querySelectorAll('.milestone-year')
                            .forEach(($button) => {
                                const startIndex = parseInt(
                                    $button.dataset.startIndex,
                                    10
                                )
                                const endIndex = parseInt(
                                    $button.dataset.endIndex,
                                    10
                                )

                                if (
                                    startIndex <= this.activeIndex &&
                                    endIndex > this.activeIndex
                                ) {
                                    $button.classList.add('is-active')
                                }
                            })
                    }
                },
            },
            speed: 500,
            slidesPerView: 1,
            autoHeight: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            navigation: {
                prevEl: $navSlider.querySelector('.slider-prev'),
                nextEl: $navSlider.querySelector('.slider-next'),
            },
        })

        on('click', '.milestone-year', function () {
            let index = slider.slides.length - 1

            if (!this.classList.contains('is-today')) {
                index = this.dataset.startIndex
            }

            navSlider.slideTo(index)
        })
    },
}

export default {
    can: () => $slider,
    run: fn.init,
}
